import styled from "styled-components";
import {Colors, FlexBox, INTER, SPACING} from "@brg/ui";
import { LayoutConst } from "core";

export const FtblCoverImageWrapper = styled.div`
    padding: ${SPACING.S_8}px;
    width: 270px;
    height: 380px;
    background: #E6E9FF;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 166px;
        height: 235px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc((100vw - 30px) / 2);
        height: calc(((100vw - 30px) / 2) * 1.4138);
    }
`;

export const FtblCoverImageInner = styled(FlexBox)`
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    height: 100%;
`;

export const FtblCoverImageBlock = styled(FlexBox)<{ isReverse?: boolean }>`
    gap: ${SPACING.S_4}px;
    align-self: stretch;
    flex-direction: ${({ isReverse }) => isReverse ? 'column-reverse' : 'column'};

    @media (max-width: ${LayoutConst.screen.l}px) {
        gap: ${SPACING.S_2}px;
    }
`;

export const FtblCoverImageFlag = styled(FlexBox)`
    width: 100%;
    aspect-ratio: 5/3;

    img {
        width: 100%;
        height: 100%;
    }
`;

export const FtblCoverFallbackFlag = styled(FlexBox)`
    width: 100%;
    padding: ${SPACING.S_16}px ${SPACING.S_24}px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${SPACING.S_16}px;
    background: #F5F5F5;
    aspect-ratio: 5/3;
`;

export const FtblCoverFallbackCountry = styled(FlexBox)`
    color: #BBB;
    text-align: center;
    font-family: "Alumni Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;
`;

export const FtblCoverImageInfo = styled(FlexBox)`
    align-items: center;
    gap: 3.836px;
    align-self: stretch;

    @media (max-width: ${LayoutConst.screen.l}px) {
        gap: 2.365px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 2.054px;
    }
`;

export const FtblCoverImageName = styled.div`
    color: ${Colors.galBlack73};
    ${INTER.F_15_20_Semibold};

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 11px;
        line-height: 13px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 10px;
        line-height: 13px;
    }
`;

export const FtblCoverImageScore = styled.div`
    flex: 1 0 0;
    color: ${Colors.galBlack100};
    text-align: right;
    ${INTER.F_20_25_Semibold};

    @media (max-width: ${LayoutConst.screen.l}px) {
        ${INTER.F_13_16_Semibold};
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const FtblCoverImageNoScoreInfo = styled(FlexBox)`
    justify-content: flex-end;
    align-items: flex-end;
    gap: 7px;
    align-self: stretch;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        margin: ${SPACING.S_2}px 0;
    }
`;

export const FtblCoverImageNames = styled(FlexBox)`
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 7px;
    flex: 1 0 0;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 0;
        justify-content: space-between;
    }
`;

export const FtblCoverImageDates = styled(FlexBox)`
    flex-direction: column;
    align-items: flex-start;
    color: ${Colors.galBlack100};
    text-align: right;
    ${INTER.F_13_16_Reg};

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;
import styled from "styled-components";
import {Colors, FlexBox, INTER, SPACING} from "@brg/ui";
import { LayoutConst } from "core";

export const FtblCoverImageWrapper = styled.div`
    padding: ${SPACING.S_8}px;
    width: 270px;
    height: 380px;
    background: #E6E9FF;

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 166px;
        height: 235px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc((100vw - 30px) / 2);
        height: calc(((100vw - 30px) / 2) * 1.4138);
    }
`;

export const FtblCoverImageInner = styled(FlexBox)`
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    height: 100%;
`;

export const FtblCoverImageBlock = styled(FlexBox)<{ isReverse?: boolean }>`
    gap: ${SPACING.S_4}px;
    align-self: stretch;
    flex-direction: ${({ isReverse }) => isReverse ? 'column-reverse' : 'column'};

    @media (max-width: ${LayoutConst.screen.l}px) {
        gap: ${SPACING.S_2}px;
    }
`;

export const FtblCoverImageFlag = styled(FlexBox)`
    width: 100%;
    aspect-ratio: 5/3;

    img {
        width: 100%;
        height: 100%;
    }
`;

export const FtblCoverFallbackFlag = styled(FlexBox)`
    width: 100%;
    padding: ${SPACING.S_16}px ${SPACING.S_24}px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${SPACING.S_16}px;
    background: #F5F5F5;
    aspect-ratio: 5/3;
`;

export const FtblCoverFallbackCountry = styled(FlexBox)`
    color: #BBB;
    text-align: center;
    font-family: "Alumni Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;
`;

export const FtblCoverImageInfo = styled(FlexBox)`
    align-items: center;
    gap: 3.836px;
    align-self: stretch;

    @media (max-width: ${LayoutConst.screen.l}px) {
        gap: 2.365px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 2.054px;
    }
`;

export const FtblCoverImageName = styled.div`
    color: ${Colors.galBlack73};
    ${INTER.F_15_20_Semibold};

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 11px;
        line-height: 13px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 10px;
        line-height: 13px;
    }
`;

export const FtblCoverImageScore = styled.div`
    flex: 1 0 0;
    color: ${Colors.galBlack100};
    text-align: right;
    ${INTER.F_20_25_Semibold};

    @media (max-width: ${LayoutConst.screen.l}px) {
        ${INTER.F_13_16_Semibold};
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const FtblCoverImageNoScoreInfo = styled(FlexBox)`
    justify-content: flex-end;
    align-items: flex-end;
    gap: 7px;
    align-self: stretch;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        margin: ${SPACING.S_2}px 0;
    }
`;

export const FtblCoverImageNames = styled(FlexBox)`
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 7px;
    flex: 1 0 0;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        gap: 0;
        justify-content: space-between;
    }
`;

export const FtblCoverImageDates = styled(FlexBox)`
    flex-direction: column;
    align-items: flex-start;
    color: ${Colors.galBlack100};
    text-align: right;
    ${INTER.F_13_16_Reg};

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;
